import React, { useState } from 'react';
import './SimultanisEditor.css';

function generateUniqueId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}

function SimultanisEditor({ availableBundles, selectedBundles, setSelectedBundles }) {
    const [lastDropdownValue, setLastDropdownValue] = useState("");

    const handleSimultaniChange = (index) => (event) => {
        const value = event.target.value;
        const updatedBundles = [...selectedBundles];

        if (value === "") {
            updatedBundles.splice(index, 1);
        } else {
            const newBundle = availableBundles.find(bundle => bundle.id === value);

            const bundleData = {
                ...newBundle,
                part_id: generateUniqueId()
            };

            if (index === updatedBundles.length) {
                updatedBundles.push(bundleData);
                setLastDropdownValue("");
            } else {
                updatedBundles[index] = bundleData;
            }
        }

        setSelectedBundles(updatedBundles);
    };

    const handleRemove = (index) => () => {
        const updatedBundles = [...selectedBundles];
        updatedBundles.splice(index, 1);
        setSelectedBundles(updatedBundles);
    };

    return (
        <div className="simultanis-editor">
            <div className="simultanis-editor-title">Parts simultànies</div>

            <div className="simultanis-editor-list">
                {selectedBundles.map((bundle, index) => (
                    <div key={bundle.part_id} className="simultanis-editor-item">
                        <div className="simultanis-editor-item-name">{bundle.nom}</div>
                        <select
                            className="simultanis-editor-select"
                            onChange={handleSimultaniChange(index)}
                            value={bundle.id}
                        >
                            <option value="">--</option>
                            {availableBundles.map(b => (
                                <option key={b.id} value={b.id}>{b.nom}</option>
                            ))}
                        </select>
                        <button
                            className="simultanis-editor-remove-btn"
                            onClick={handleRemove(index)}
                            title="Treu"
                        >
                            &times;
                        </button>
                    </div>
                ))}
            </div>

            <div className="simultanis-editor-add">
                <div className="simultanis-editor-add-label">Afegir...</div>
                <select
                    className="simultanis-editor-select"
                    onChange={handleSimultaniChange(selectedBundles.length)}
                    value={lastDropdownValue}
                >
                    <option value="">--</option>
                    {availableBundles.map(b => (
                        <option key={b.id} value={b.id}>{b.nom}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}

export default SimultanisEditor;